"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _Heading = require("../Heading/Heading.styles");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var parts = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];
var baseStyle = {
  table: {
    borderCollapse: 'collapse',
    color: 'text.primary.light',
    width: '100%'
  },
  thead: {
    borderBottom: '1px',
    borderColor: 'gray.medium'
  },
  th: {
    fontFamily: 'heading',
    fontSize: _Heading.variants.h4.fontSize,
    fontWeight: 'semibold',
    letterSpacing: 'unset',
    padding: 4,
    textAlign: 'start',
    textTransform: 'none'
  },
  tr: {
    borderBottom: '1px',
    borderColor: 'gray.medium',
    _last: {
      border: 'none'
    }
  },
  td: {
    padding: 4,
    textAlign: 'start'
  }
};
var roundedWhiteVariant = {
  table: {
    backgroundColor: 'background.white',
    borderRadius: 6,
    boxShadow: 'md',
    marginBottom: 1
  }
};
var roundedGrayVariant = {
  table: _objectSpread(_objectSpread({}, roundedWhiteVariant.table), {}, {
    backgroundColor: 'background.gray'
  })
};
var variants = exports.variants = {
  rounded: roundedWhiteVariant,
  roundedGray: roundedGrayVariant
};
var defaultProps = {
  variant: 'rounded'
};
var _default = exports["default"] = {
  parts: parts,
  variants: variants,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};